import { c as _c } from "react/compiler-runtime";
import { HotelCardLink, HotelCardLinkProperties, hotelCardOnClick } from "@website/accommodation-ui/hotel-card-new/hotel-card-link";
import { HotelCardThumbnail } from "@website/accommodation-ui/hotel-card-new/hotel-card-thumbnail";
import { HotelCardPropertiesType } from "@website/accommodation-ui/hotel-card-new/hotel-card.types";
import { useIsVisible } from "@website/hooks/is-visible";
import { useViewPort } from "@website/hooks/viewport";
import { addEventToDataLayer } from "@website/tracking/tracking.gtm";
import { DATA_LAYER_EVENTS, USER_TRACKING_EVENTS } from "@website/tracking/tracking.types";
import { ApplicationNameType, addEventToTracking, mapProductForUserTracking } from "@website/tracking/user";
import { Button } from "@website/ui/button";
import { MiniPopover } from "@website/ui/mini-popover";
import { useCompatRouter } from "@website/widget-v2/helpers/compat-router.hook";
import omit from "lodash-es/omit";
import { FC, useEffect, useState } from "react";
import { HotelSnappPayBadge } from "../hotel-snapp-pay";
import { HotelCardAction } from "./hotel-card-action";
import { HotelCardPricing } from "./hotel-card-action/hotel-card-pricing";
import { HotelCardInfo } from "./hotel-card-info";
const appName = process.env.NEXT_PUBLIC_APP_NAME as ApplicationNameType;
export const HotelCardDivider: FC<Pick<HotelCardPropertiesType, "size">> = t0 => {
  const $ = _c(8);
  const {
    size
  } = t0;
  const t1 = `block h-px w-full ${size === "small" ? "" : "lg:hidden"}`;
  let t2;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = {
      background: "repeating-linear-gradient(to right, #EBECF2 0, #EBECF2 4px, transparent 4px, transparent 8px)"
    };
    $[0] = t2;
  } else {
    t2 = $[0];
  }
  let t3;
  if ($[1] !== t1) {
    t3 = <div className={t1} style={t2} />;
    $[1] = t1;
    $[2] = t3;
  } else {
    t3 = $[2];
  }
  let t4;
  if ($[3] !== size) {
    t4 = size !== "small" && <div className="h-full w-px" style={{
      background: "repeating-linear-gradient(to bottom, #EBECF2 0, #EBECF2 4px, transparent 4px, transparent 8px)"
    }} />;
    $[3] = size;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  let t5;
  if ($[5] !== t3 || $[6] !== t4) {
    t5 = <>{t3}{t4}</>;
    $[5] = t3;
    $[6] = t4;
    $[7] = t5;
  } else {
    t5 = $[7];
  }
  return t5;
};
export const HotelCard: FC<HotelCardPropertiesType> = properties => {
  const $ = _c(141);
  const {
    isMobile
  } = useViewPort();
  const [clickLoading, setClickLoading] = useState(0);
  const isHomePage = process.env.NEXT_PUBLIC_APP_NAME === "homepage" || process.env.NEXT_PUBLIC_APP_NAME === "website";
  const {
    className,
    loading,
    hotelInfo,
    size: t0,
    index,
    replace,
    snappPayData,
    isSuggestedCard,
    utm,
    onMouseEnter,
    onMouseLeave,
    onLinkClick,
    targetLink,
    showMap,
    shouldRedirectUsingJs,
    showCarousel: t1,
    isLanding,
    homePageSectionName,
    isHotelDomHomePage,
    isPriorityImage,
    isVillaHomePage: t2,
    noFollow,
    prefetch,
    isLastMinute,
    actionButtonText
  } = properties;
  const size = t0 === undefined ? "responsive" : t0;
  const showCarousel = t1 === undefined ? true : t1;
  const isVillaHomePage = t2 === undefined ? false : t2;
  const {
    id,
    hotelDetail,
    hotelOffers,
    thumbnail,
    pricing,
    reservationInfo,
    primaryBadge,
    regularBadges,
    advertisementBadge,
    facilities,
    gallery,
    location,
    categories,
    hasSnappProDiscount,
    transportation,
    isInternational
  } = hotelInfo;
  const router = useCompatRouter();
  const {
    isDesktop
  } = useViewPort();
  const {
    reference,
    inView
  } = useIsVisible();
  let t3;
  if ($[0] !== router) {
    t3 = () => router.replace(router?.pathname, omit(router?.query, "modal"), {
      shallow: true,
      scroll: false
    });
    $[0] = router;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const onClose = t3;
  let t4;
  if ($[2] !== hotelInfo.hotelDetail || $[3] !== hotelInfo.id || $[4] !== hotelInfo.pricing || $[5] !== hotelInfo.ruleId || $[6] !== inView || $[7] !== index || $[8] !== router.query) {
    t4 = () => {
      if (!inView) {
        return;
      }
      if (isHomePage) {
        return;
      }
      addEventToDataLayer(DATA_LAYER_EVENTS.VIEW_ITEM_LIST, {
        items: [{
          item_name: hotelInfo?.hotelDetail?.hotelTitle,
          item_id: hotelInfo?.id,
          price: hotelInfo?.pricing?.price,
          item_brand: "IRR",
          item_category: hotelInfo?.hotelDetail?.cityTitle,
          item_category2: hotelInfo?.hotelDetail?.accommodationType,
          item_category3: hotelInfo?.hotelDetail?.stars,
          item_list_name: `هتل های ${hotelInfo?.hotelDetail?.cityTitle}`,
          item_list_id: hotelInfo?.hotelDetail?.cityId,
          index
        }]
      });
      const payload = {
        position: index,
        accommodation_id: hotelInfo.id
      };
      if (["villa", "hotel-domestic", "hotel-international"].includes(appName)) {
        addEventToTracking(USER_TRACKING_EVENTS.HOTEL_CARD_VIEWED, {
          date_from: String(router.query.date_from) || "",
          date_to: String(router.query.date_to) || "",
          city: hotelInfo.hotelDetail?.cityTitle,
          city_id: hotelInfo.hotelDetail?.cityId,
          hotel: hotelInfo.hotelDetail?.hotelTitle,
          hotel_id: hotelInfo.id,
          price: hotelInfo.pricing.price,
          price_off: hotelInfo.pricing.priceOff,
          discount_percent: hotelInfo.pricing.discountPercentage,
          is_available: hotelInfo.hotelDetail.isAvailable,
          price_engine_rules: [{
            id: hotelInfo?.ruleId ?? 0,
            title: ""
          }],
          product: mapProductForUserTracking(appName),
          ...payload
        });
      }
    };
    $[2] = hotelInfo.hotelDetail;
    $[3] = hotelInfo.id;
    $[4] = hotelInfo.pricing;
    $[5] = hotelInfo.ruleId;
    $[6] = inView;
    $[7] = index;
    $[8] = router.query;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== hotelInfo || $[11] !== inView || $[12] !== index || $[13] !== router) {
    t5 = [hotelInfo, inView, index, router];
    $[10] = hotelInfo;
    $[11] = inView;
    $[12] = index;
    $[13] = router;
    $[14] = t5;
  } else {
    t5 = $[14];
  }
  useEffect(t4, t5);
  const t6 = hotelInfo?.hotelDetail?.hotelPageUrl?.href;
  const t7 = hotelInfo?.hotelDetail?.hotelPageUrl?.pathname;
  const t8 = hotelInfo?.hotelDetail?.hotelPageUrl?.query as object;
  let t9;
  if ($[15] !== router.query || $[16] !== t8) {
    t9 = {
      ...router.query,
      ...t8
    };
    $[15] = router.query;
    $[16] = t8;
    $[17] = t9;
  } else {
    t9 = $[17];
  }
  const t10 = !isSuggestedCard && replace;
  const t11 = hotelDetail?.hotelTitle;
  let t12;
  if ($[18] !== homePageSectionName || $[19] !== hotelInfo || $[20] !== index || $[21] !== isLastMinute || $[22] !== noFollow || $[23] !== onLinkClick || $[24] !== prefetch || $[25] !== shouldRedirectUsingJs || $[26] !== t10 || $[27] !== t11 || $[28] !== t6 || $[29] !== t7 || $[30] !== t9 || $[31] !== targetLink || $[32] !== utm) {
    t12 = {
      hotelInfo,
      href: t6,
      pathname: t7,
      query: t9,
      setClickLoading,
      index,
      utm,
      replace: t10,
      target: targetLink,
      title: t11,
      shouldRedirectUsingJs,
      children: "",
      onLinkClick,
      homePageSectionName,
      isHomePage,
      isLastMinute,
      noFollow,
      prefetch
    };
    $[18] = homePageSectionName;
    $[19] = hotelInfo;
    $[20] = index;
    $[21] = isLastMinute;
    $[22] = noFollow;
    $[23] = onLinkClick;
    $[24] = prefetch;
    $[25] = shouldRedirectUsingJs;
    $[26] = t10;
    $[27] = t11;
    $[28] = t6;
    $[29] = t7;
    $[30] = t9;
    $[31] = targetLink;
    $[32] = utm;
    $[33] = t12;
  } else {
    t12 = $[33];
  }
  const linkProperties = t12;
  const t13 = `bg-on-color-high-emphasis shadow-1 flex flex-col overflow-hidden rounded-2xl p-0 sm:p-3 ${className} ${size === "small" ? `${appName === "villa" ? "" : "cursor-pointer"} h-full gap-3` : "md:flex-row"} ${size === "xSmall" ? "h-[118px] w-[272px] cursor-pointer !flex-row items-center gap-2 !rounded-[8px] !p-2 !shadow-none" : ""}`;
  let t14;
  if ($[34] !== id || $[35] !== onMouseEnter) {
    t14 = () => onMouseEnter?.(Number(id));
    $[34] = id;
    $[35] = onMouseEnter;
    $[36] = t14;
  } else {
    t14 = $[36];
  }
  let t15;
  if ($[37] !== id || $[38] !== onMouseLeave) {
    t15 = () => onMouseLeave?.(Number(id));
    $[37] = id;
    $[38] = onMouseLeave;
    $[39] = t15;
  } else {
    t15 = $[39];
  }
  let t16;
  if ($[40] !== homePageSectionName || $[41] !== hotelInfo || $[42] !== index || $[43] !== isLastMinute || $[44] !== onLinkClick || $[45] !== router || $[46] !== size || $[47] !== utm) {
    t16 = size === "xSmall" || size === "small" && appName !== "villa" ? hotelCardOnClick({
      query: utm,
      router,
      setClickLoading,
      index,
      hotelInfo,
      onLinkClick,
      homePageSectionName,
      isHomePage,
      isLastMinute
    }) : undefined;
    $[40] = homePageSectionName;
    $[41] = hotelInfo;
    $[42] = index;
    $[43] = isLastMinute;
    $[44] = onLinkClick;
    $[45] = router;
    $[46] = size;
    $[47] = utm;
    $[48] = t16;
  } else {
    t16 = $[48];
  }
  const t17 = hotelOffers?.specialOffer;
  const t18 = hotelDetail?.stars;
  const t19 = hotelDetail?.hotelTitle;
  let t20;
  if ($[49] !== gallery || $[50] !== id || $[51] !== isPriorityImage || $[52] !== primaryBadge || $[53] !== showCarousel || $[54] !== size || $[55] !== t17 || $[56] !== t18 || $[57] !== t19 || $[58] !== thumbnail) {
    t20 = <HotelCardThumbnail gallery={gallery} id={id} isPriorityImage={isPriorityImage} primaryBadge={primaryBadge} showCarousel={showCarousel} size={size} specialOffer={t17} stars={t18} thumbnail={thumbnail} title={t19} />;
    $[49] = gallery;
    $[50] = id;
    $[51] = isPriorityImage;
    $[52] = primaryBadge;
    $[53] = showCarousel;
    $[54] = size;
    $[55] = t17;
    $[56] = t18;
    $[57] = t19;
    $[58] = thumbnail;
    $[59] = t20;
  } else {
    t20 = $[59];
  }
  let t21;
  if ($[60] !== linkProperties || $[61] !== t20) {
    t21 = <HotelCardLink {...linkProperties} className="md:flex">{t20}</HotelCardLink>;
    $[60] = linkProperties;
    $[61] = t20;
    $[62] = t21;
  } else {
    t21 = $[62];
  }
  const t22 = `flex min-w-0 shrink grow flex-col ${size === "xSmall" ? "h-full" : ""}`;
  const t23 = `flex h-full flex-col px-3 ${isLanding || size === "small" ? "!pb-3 sm:!pb-0" : "pb-1"} sm:p-0 md:gap-3 ${size === "xSmall" ? "!gap-1 !px-0" : ""} ${["small", "xSmall"].includes(size) ? "" : "lg:flex-row"}`;
  const t24 = hotelDetail?.isInstant;
  let t25;
  if ($[63] !== hotelOffers?.offers) {
    t25 = hotelOffers?.offers || [];
    $[63] = hotelOffers?.offers;
    $[64] = t25;
  } else {
    t25 = $[64];
  }
  const t26 = hotelDetail?.propertyId;
  const t27 = showMap && !isMobile;
  let t28;
  if ($[65] !== advertisementBadge || $[66] !== categories || $[67] !== facilities || $[68] !== hasSnappProDiscount || $[69] !== hotelDetail || $[70] !== id || $[71] !== isHotelDomHomePage || $[72] !== isInternational || $[73] !== isSuggestedCard || $[74] !== linkProperties || $[75] !== loading || $[76] !== location || $[77] !== pricing || $[78] !== regularBadges || $[79] !== reservationInfo || $[80] !== size || $[81] !== snappPayData || $[82] !== t24 || $[83] !== t25 || $[84] !== t26 || $[85] !== t27 || $[86] !== transportation) {
    t28 = <HotelCardInfo {...hotelDetail} isHotelDomHomePage={isHotelDomHomePage} linkProperties={linkProperties} advertisementBadge={advertisementBadge} facilities={facilities} id={id} isInstant={t24} isSuggestedCard={isSuggestedCard} loading={loading} location={location} offers={t25} pricing={pricing} propertyId={t26} regularBadges={regularBadges} reservationInfo={reservationInfo} showMap={t27} size={size} snappPayData={snappPayData} categories={categories} hasSnappProDiscount={hasSnappProDiscount} transportation={transportation} isInternational={isInternational} />;
    $[65] = advertisementBadge;
    $[66] = categories;
    $[67] = facilities;
    $[68] = hasSnappProDiscount;
    $[69] = hotelDetail;
    $[70] = id;
    $[71] = isHotelDomHomePage;
    $[72] = isInternational;
    $[73] = isSuggestedCard;
    $[74] = linkProperties;
    $[75] = loading;
    $[76] = location;
    $[77] = pricing;
    $[78] = regularBadges;
    $[79] = reservationInfo;
    $[80] = size;
    $[81] = snappPayData;
    $[82] = t24;
    $[83] = t25;
    $[84] = t26;
    $[85] = t27;
    $[86] = transportation;
    $[87] = t28;
  } else {
    t28 = $[87];
  }
  let t29;
  if ($[88] !== size) {
    t29 = size !== "xSmall" && <div className="md:ps-4 lg:ps-0"><HotelCardDivider size={size} /></div>;
    $[88] = size;
    $[89] = t29;
  } else {
    t29 = $[89];
  }
  let t30;
  if ($[90] !== actionButtonText || $[91] !== clickLoading || $[92] !== hasSnappProDiscount || $[93] !== hotelDetail?.isAvailable || $[94] !== hotelDetail?.isFomo || $[95] !== hotelDetail?.roomCount || $[96] !== hotelDetail?.roomTitle || $[97] !== id || $[98] !== isHotelDomHomePage || $[99] !== isLanding || $[100] !== isVillaHomePage || $[101] !== linkProperties || $[102] !== loading || $[103] !== pricing || $[104] !== reservationInfo || $[105] !== size) {
    t30 = size === "xSmall" ? <HotelCardPricing {...pricing} size={size} hasSnappProDiscount={hasSnappProDiscount} /> : <HotelCardAction isLanding={isLanding} linkProperties={linkProperties} clickLoading={clickLoading === id} isAvailable={hotelDetail?.isAvailable} isFomo={hotelDetail?.isFomo} loading={loading} pricingInfo={pricing} reservationInfo={reservationInfo} roomCount={hotelDetail?.roomCount} roomTitle={hotelDetail?.roomTitle} size={size} hasSnappProDiscount={hasSnappProDiscount} isHotelDomHomePage={isHotelDomHomePage} isVillaHomePage={isVillaHomePage} actionButtonText={actionButtonText} />;
    $[90] = actionButtonText;
    $[91] = clickLoading;
    $[92] = hasSnappProDiscount;
    $[93] = hotelDetail?.isAvailable;
    $[94] = hotelDetail?.isFomo;
    $[95] = hotelDetail?.roomCount;
    $[96] = hotelDetail?.roomTitle;
    $[97] = id;
    $[98] = isHotelDomHomePage;
    $[99] = isLanding;
    $[100] = isVillaHomePage;
    $[101] = linkProperties;
    $[102] = loading;
    $[103] = pricing;
    $[104] = reservationInfo;
    $[105] = size;
    $[106] = t30;
  } else {
    t30 = $[106];
  }
  let t31;
  if ($[107] !== t23 || $[108] !== t28 || $[109] !== t29 || $[110] !== t30) {
    t31 = <div className={t23}>{t28}{t29}{t30}</div>;
    $[107] = t23;
    $[108] = t28;
    $[109] = t29;
    $[110] = t30;
    $[111] = t31;
  } else {
    t31 = $[111];
  }
  let t32;
  if ($[112] !== t22 || $[113] !== t31) {
    t32 = <div className={t22}>{t31}</div>;
    $[112] = t22;
    $[113] = t31;
    $[114] = t32;
  } else {
    t32 = $[114];
  }
  let t33;
  if ($[115] !== loading || $[116] !== pricing?.price || $[117] !== pricing?.priceOff || $[118] !== size || $[119] !== snappPayData) {
    t33 = size !== "small" && size !== "xSmall" && <div className="mt-2 block md:hidden"><HotelSnappPayBadge {...snappPayData} loading={loading} page="cityPage" price={pricing?.priceOff || pricing?.price} /></div>;
    $[115] = loading;
    $[116] = pricing?.price;
    $[117] = pricing?.priceOff;
    $[118] = size;
    $[119] = snappPayData;
    $[120] = t33;
  } else {
    t33 = $[120];
  }
  let t34;
  if ($[121] !== reference || $[122] !== t13 || $[123] !== t14 || $[124] !== t15 || $[125] !== t16 || $[126] !== t21 || $[127] !== t32 || $[128] !== t33) {
    t34 = <div className={t13} onMouseEnter={t14} onMouseLeave={t15} onClick={t16} ref={reference}>{t21}{t32}{t33}</div>;
    $[121] = reference;
    $[122] = t13;
    $[123] = t14;
    $[124] = t15;
    $[125] = t16;
    $[126] = t21;
    $[127] = t32;
    $[128] = t33;
    $[129] = t34;
  } else {
    t34 = $[129];
  }
  let t35;
  if ($[130] !== id || $[131] !== isDesktop || $[132] !== onClose || $[133] !== primaryBadge?.description || $[134] !== primaryBadge?.text || $[135] !== router.query?.modal || $[136] !== size) {
    t35 = size !== "xSmall" && primaryBadge?.text && router?.query?.modal === `badge-info-${id}` && !isDesktop && <div className="block md:hidden"><MiniPopover onClose={onClose} open={router?.query?.modal === `badge-info-${id}`} title={primaryBadge?.text} className="!z-[100]"><div className="flex w-full flex-col gap-4 px-6 pb-6"><span className="text-body-2">{primaryBadge?.description}</span><Button color="secondary" onClick={onClose} text={"\u0645\u062A\u0648\u062C\u0647 \u0634\u062F\u0645"} variant="outline" /></div></MiniPopover></div>;
    $[130] = id;
    $[131] = isDesktop;
    $[132] = onClose;
    $[133] = primaryBadge?.description;
    $[134] = primaryBadge?.text;
    $[135] = router.query?.modal;
    $[136] = size;
    $[137] = t35;
  } else {
    t35 = $[137];
  }
  let t36;
  if ($[138] !== t34 || $[139] !== t35) {
    t36 = <>{t34}{t35}</>;
    $[138] = t34;
    $[139] = t35;
    $[140] = t36;
  } else {
    t36 = $[140];
  }
  return t36;
};